// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/close.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/ProductCard/ProductCard.css */
.product-card {
    background-color: var(--color-white);
    border-radius: var(--radius-md);
    padding: var(--space-2) var(--space-3);
    text-align: left;
    height: 280px; /* Adjust as needed */
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative; /* Added for absolute positioning of delete button */
    border: 1px solid var(--color-border-subtle);
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  .product-card-clickable {
    cursor: pointer;
    border: 1px solid var(--color-border-subtle);
    font: inherit;
    color: inherit;
    background-color: var(--color-white);
    -webkit-tap-highlight-color: transparent;
  }

  .product-card-clickable:focus {
    outline: 2px solid var(--color-primary-green);
    outline-offset: 2px;
  }

  .product-card-clickable:focus:not(:focus-visible) {
    outline: none;
  }
  
  .product-card:hover {
    border-color: var(--color-gray);
    box-shadow: var(--shadow-sm);
  }
  
  .product-card-image {
    width: auto;
    height: 148px;
    object-fit: scale-down;
    border-radius: var(--radius-sm);
  }
  
  .product-card-bottom {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;
    min-height: 0;
    margin-top: 8px;
    justify-content: space-between;
  }
  
  .product-card-content {
    display: flex;
    flex-direction: column;
  }

  .product-card-content p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
  }

  .product-card-content h3 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
  }
  
  .delete-button {
    position: absolute !important;
    top: 8px !important;
    right: 8px !important;
    background-color: rgba(255, 255, 255, 0.9) !important;
    color: var(--color-dark-gray) !important;
    z-index: 1;
    width: 24px !important;
    height: 24px !important;
    padding: 0 !important;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
    background-size: 16px 16px !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
  }
  
  .delete-button:hover {
    background-color: var(--color-white) !important;
    color: var(--color-primary-red) !important;
  }
  
  .add-product-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: var(--color-surface-muted);
    border: 1px dashed var(--color-gray);
    color: var(--color-primary-green);
    transition: border-color 0.2s, box-shadow 0.2s;
  }

  .add-product-card:hover, .add-product-card:focus {
    border-color: var(--color-primary-green);
    box-shadow: var(--shadow-sm);
  }

  .add-product-card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .add-product-icon {
    margin-bottom: 8px;
    color: var(--color-primary-green);
  }

  .add-product-text {
    color: var(--color-primary-green);
  }
  
  /* Responsive adjustments for mobile */
  @media (max-width: 480px) {
    .product-card {
      height: 260px;
      width: 100%;
      padding: 6px 10px;
    }
    
    .product-card-image {
      height: 130px;
    }
  }
  
  @media (max-width: 360px) {
    .product-card {
      height: 240px;
      width: 100%;
      padding: 5px 8px;
    }
    
    .product-card-image {
      height: 120px;
    }
  }
  
  /* Responsive adjustments for AddProductCard */
  @media (max-width: 480px) {
    .add-product-card {
      height: 260px;
      width: 100%;
    }
  }
  
  @media (max-width: 360px) {
    .add-product-card {
      height: 240px;
      width: 100%;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/ProductCard/ProductCard.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C;IACI,oCAAoC;IACpC,+BAA+B;IAC/B,sCAAsC;IACtC,gBAAgB;IAChB,aAAa,EAAE,qBAAqB;IACpC,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB,EAAE,oDAAoD;IACxE,4CAA4C;IAC5C,wDAAwD;EAC1D;;EAEA;IACE,eAAe;IACf,4CAA4C;IAC5C,aAAa;IACb,cAAc;IACd,oCAAoC;IACpC,wCAAwC;EAC1C;;EAEA;IACE,6CAA6C;IAC7C,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,+BAA+B;IAC/B,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,OAAO;IACP,aAAa;IACb,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,aAAa;IACb,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,aAAa;IACb,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,6BAA6B;IAC7B,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;IACrD,wCAAwC;IACxC,UAAU;IACV,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,oEAA0D;IAC1D,qCAAqC;IACrC,sCAAsC;IACtC,uCAAuC;EACzC;;EAEA;IACE,+CAA+C;IAC/C,0CAA0C;EAC5C;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,sCAAsC;IACtC,oCAAoC;IACpC,iCAAiC;IACjC,8CAA8C;EAChD;;EAEA;IACE,wCAAwC;IACxC,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,iCAAiC;EACnC;;EAEA;IACE,iCAAiC;EACnC;;EAEA,sCAAsC;EACtC;IACE;MACE,aAAa;MACb,WAAW;MACX,iBAAiB;IACnB;;IAEA;MACE,aAAa;IACf;EACF;;EAEA;IACE;MACE,aAAa;MACb,WAAW;MACX,gBAAgB;IAClB;;IAEA;MACE,aAAa;IACf;EACF;;EAEA,8CAA8C;EAC9C;IACE;MACE,aAAa;MACb,WAAW;IACb;EACF;;EAEA;IACE;MACE,aAAa;MACb,WAAW;IACb;EACF","sourcesContent":["/* src/components/ProductCard/ProductCard.css */\n.product-card {\n    background-color: var(--color-white);\n    border-radius: var(--radius-md);\n    padding: var(--space-2) var(--space-3);\n    text-align: left;\n    height: 280px; /* Adjust as needed */\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    position: relative; /* Added for absolute positioning of delete button */\n    border: 1px solid var(--color-border-subtle);\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  }\n\n  .product-card-clickable {\n    cursor: pointer;\n    border: 1px solid var(--color-border-subtle);\n    font: inherit;\n    color: inherit;\n    background-color: var(--color-white);\n    -webkit-tap-highlight-color: transparent;\n  }\n\n  .product-card-clickable:focus {\n    outline: 2px solid var(--color-primary-green);\n    outline-offset: 2px;\n  }\n\n  .product-card-clickable:focus:not(:focus-visible) {\n    outline: none;\n  }\n  \n  .product-card:hover {\n    border-color: var(--color-gray);\n    box-shadow: var(--shadow-sm);\n  }\n  \n  .product-card-image {\n    width: auto;\n    height: 148px;\n    object-fit: scale-down;\n    border-radius: var(--radius-sm);\n  }\n  \n  .product-card-bottom {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    flex: 1;\n    min-height: 0;\n    margin-top: 8px;\n    justify-content: space-between;\n  }\n  \n  .product-card-content {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .product-card-content p {\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    margin: 0;\n  }\n\n  .product-card-content h3 {\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    margin: 0;\n  }\n  \n  .delete-button {\n    position: absolute !important;\n    top: 8px !important;\n    right: 8px !important;\n    background-color: rgba(255, 255, 255, 0.9) !important;\n    color: var(--color-dark-gray) !important;\n    z-index: 1;\n    width: 24px !important;\n    height: 24px !important;\n    padding: 0 !important;\n    background-image: url('../../assets/close.svg') !important;\n    background-size: 16px 16px !important;\n    background-position: center !important;\n    background-repeat: no-repeat !important;\n  }\n  \n  .delete-button:hover {\n    background-color: var(--color-white) !important;\n    color: var(--color-primary-red) !important;\n  }\n  \n  .add-product-card {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    background: var(--color-surface-muted);\n    border: 1px dashed var(--color-gray);\n    color: var(--color-primary-green);\n    transition: border-color 0.2s, box-shadow 0.2s;\n  }\n\n  .add-product-card:hover, .add-product-card:focus {\n    border-color: var(--color-primary-green);\n    box-shadow: var(--shadow-sm);\n  }\n\n  .add-product-card-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .add-product-icon {\n    margin-bottom: 8px;\n    color: var(--color-primary-green);\n  }\n\n  .add-product-text {\n    color: var(--color-primary-green);\n  }\n  \n  /* Responsive adjustments for mobile */\n  @media (max-width: 480px) {\n    .product-card {\n      height: 260px;\n      width: 100%;\n      padding: 6px 10px;\n    }\n    \n    .product-card-image {\n      height: 130px;\n    }\n  }\n  \n  @media (max-width: 360px) {\n    .product-card {\n      height: 240px;\n      width: 100%;\n      padding: 5px 8px;\n    }\n    \n    .product-card-image {\n      height: 120px;\n    }\n  }\n  \n  /* Responsive adjustments for AddProductCard */\n  @media (max-width: 480px) {\n    .add-product-card {\n      height: 260px;\n      width: 100%;\n    }\n  }\n  \n  @media (max-width: 360px) {\n    .add-product-card {\n      height: 240px;\n      width: 100%;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
